export default class VideoThumbnail {

  private _id: number;
  private _url: string | undefined;
  private _width: number | undefined;
  private _height: number | undefined;

  constructor(id: number) {
    this._id = id;
  }
  public get id() {
    return this._id;
  }
  public get url() {
    return this._url;
  }
  public set url(value) {
    this._url = value;
  }
  public get width() {
    return this._width;
  }
  public set width(value) {
    this._width = value;
  }
  public get height() {
    return this._height;
  }
  public set height(value) {
    this._height = value;
  }
 
}